<nz-modal [(nzVisible)]="isVisible" [nzTitle]="null" [nzContent]="modalContent" [nzFooter]="null" [nzWidth]="380"
  [nzClosable]="false">
  <ng-template #modalContent>
    <div nz-row>
      <div nz-col nzSpan="24">
        <h2 class="text-center font-size-xl">{{'T0000.T0001' | translate}}
          <span class="text-cancel font-size-xl">{{daysRemaining}}</span>{{'T0000.T0002' | translate}}</h2>
      </div>
    </div>
    <div nz-row class="mt-2">
      <div nz-col nzSpan="24" class="pr-1">
        <div class="btn-wrapper" style="text-align: center;">
          <div (click)="close('1')" class="btn-styles text-center btn-blue body-font-size">
            <div class="txt">
              <button  class="body-font-size" type="button">{{'ok' | translate}}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</nz-modal>